import { PayloadAction, createReducer } from '@reduxjs/toolkit';
import { initialState } from '@modules/account/store';
import { accountAttachmentDeleteRoutine } from '@modules/account/actions';
import { onFailure } from '@common/utils';

export const accountAttachmentDeleteReducer = createReducer(initialState, {
  [accountAttachmentDeleteRoutine.REQUEST]: (state: typeof initialState) => {
    state.extraAttachments.isFetching = true;
    return state;
  },
  [accountAttachmentDeleteRoutine.FAILURE]: onFailure,
  [accountAttachmentDeleteRoutine.FULFILL]: (state: typeof initialState) => {
    state.extraAttachments.isFetching = false;
    return state;
  }
});
